"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EXTERNAL_URL_REGEX = /^(http:|https:)?\/\//i;
var PROTOCOL_DELIMITER_REGEXES = [/:?$/, /(:\/\/)?$/];
var PROTOCOL_DELIMITER = '://';
function isExternalUrl(url) {
    return EXTERNAL_URL_REGEX.test(url);
}
exports.isExternalUrl = isExternalUrl;
function isTrustedProtocol(url, protocols) {
    if (!url || !protocols) {
        return false;
    }
    return protocols.some(function (protocol) {
        return url.startsWith("" + PROTOCOL_DELIMITER_REGEXES.reduce(function (protocolValue, regex) { return protocolValue.replace(regex, ''); }, protocol) + PROTOCOL_DELIMITER);
    });
}
exports.isTrustedProtocol = isTrustedProtocol;
